// eslint-disable-next-line
type WithArgsFn = (...args: any) => any;

export const withLogger = (
  loggerName: string,
  withArgs: WithArgsFn = (...args) => args
) => {
  // @ts-ignore
  return (fn) => (...args) => {
    const toLog = withArgs(...args);

    if (toLog) {
      // eslint-disable-next-line
      console.log(loggerName, withArgs(...args));
    }
    // @ts-ignore
    return fn(...args);
  };
};

export default withLogger;
